<template>
    <nav
        class="flex items-center flex-row justify-between border gap-4 sm:pr-8 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 pr-2 sticky top-0 z-50"
        :class="{
            'pt-20 sm:pt-16 md:pt-12 lg:pt-8': appStore.hasBannerVisible,
            'pt-16 sm:pt-9 lg:pt-8': !appStore.hasBannerVisible,
        }"
        aria-label="Breadcrumb"
    >
        <ol
            class="flex items-center min-h-12 md:max-w-screen-xl space-x-1 md:space-x-3 px-2 sm:px-4 md:px-6 lg:px-8 md:mt-0"
            role="list"
        >
            <li class="flex items-center max-sm:hidden">
                <Link
                    href="/"
                    class="text-slate-400 dark:text-slate-500 hover:text-slate-500 dark:hover:text-slate-300 rounded px-1"
                >
                    <svg
                        class="h-5 w-5 shrink-0"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <span class="sr-only">Home</span>
                </Link>
            </li>
            <li
                v-for="(item, index) in breadcrumbs"
                :key="index"
                class="flex text-sm"
                :disabled="!item.url"
            >
                <span
                    class="flex items-center"
                    v-if="
                        item.url &&
                        item.url.length > 0 &&
                        index < breadcrumbs.length - 1
                    "
                >
                    <Link
                        class="flex items-center gap-2 rounded px-1"
                        :href="item.url"
                    >
                        <Icon
                            icon="chevron-left"
                            class="inline-block sm:hidden"
                        />
                        {{ item.title }}
                    </Link>
                    <svg
                        class="h-full w-6 shrink-0 text-slate-200 dark:text-slate-700 max-sm:hidden"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        fill="currentColor"
                        aria-hidden="true"
                        v-if="index < breadcrumbs.length - 1"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                </span>
                <span
                    class="flex items-center text-slate-400 dark:text-slate-500 max-sm:hidden"
                    v-else
                >
                    {{ item.title }}
                </span>
            </li>
        </ol>
        <a
            href="#"
            @click.prevent="appStore.setShowAffiliateModal(true)"
            class="text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-400 text-sm rounded px-1"
            id="hs-mypoints-affiliate-disclosure"
            role="button"
        >
            Affiliate Disclosure
        </a>
    </nav>
</template>

<script setup>
import { computed } from 'vue';
import { usePage, Link } from '@inertiajs/vue3';
import { useAppStore } from '@/store/app';
import Icon from '@/components/ui/icon/icon.vue';

const appStore = useAppStore();

const breadcrumbs = computed(() => usePage().props?.breadcrumbs);
</script>
